import {
	FETCH_ALERT_NOTIFY_BEGIN,
	FETCH_ALERT_NOTIFY_SUCCESS,
	FETCH_ALERT_NOTIFY_ERROR,
	FETCH_NEW_ALERT_NOTIFY_BEGIN,
	FETCH_NEW_ALERT_NOTIFY_SUCCESS,
	FETCH_NEW_ALERT_NOTIFY_ERROR
} from '../actions/alertActions';

const defaultAlertNotificationsState =  {
	alertNotifications: [],
	loading: false,
	pagination: {
		numberOfElements : 0,
		totalElements: 0,
		totalPages: 0
	},
};

const defaultNewAlertNotificationsState =  {
	loading: false,
	totalElements: 0
};

export const alertNotificationsReducer  = (state = defaultAlertNotificationsState, action) => {
	switch (action.type) {
	case FETCH_ALERT_NOTIFY_BEGIN:
		return {
			...state,
			loading: true,
		};

	case FETCH_ALERT_NOTIFY_SUCCESS:
		return {
			...state,
			loading: false,
			alertNotifications: action.payload.alertNotifications,
			pagination: {
				numberOfElements : action.payload.numberOfElements,
				totalElements: action.payload.totalElements,
				totalPages: action.payload.totalPages
			},
		};

	case FETCH_ALERT_NOTIFY_ERROR:
		return {
			...state,
			loading: false,
			alertNotifications: []
		};

	default:
		return state;
	}
};

export const alertNewNotificationsReducer  = (state = defaultNewAlertNotificationsState, action) => {
	switch (action.type) {
		case FETCH_NEW_ALERT_NOTIFY_BEGIN:
			return {
				...state,
				loading: true,
			};

		case FETCH_NEW_ALERT_NOTIFY_SUCCESS:
			return {
				...state,
				loading: false,
				totalElements: action.payload.totalElements
			};

		case FETCH_NEW_ALERT_NOTIFY_ERROR:
			return {
				...state,
				loading: false,
				totalElements: 0
			};

		default:
			return state;
	}
};


// WEBPACK FOOTER //
// ./src/reducers/alertsNotifications.js